






















import { Component, Prop, Vue } from "vue-property-decorator";
import NavBar from "../components/NavBar.vue";
import Client from "../Client";
import Action from "../store/actionTypes";

@Component({
  components: {
    NavBar
  }
})
export default class Login extends Vue {
  private confirmation_code: string = "";

  private phone_number: string = "";

  private error: string = "";

  confirmCode(evt: Event) {
    evt.preventDefault();
    this.$store
      .dispatch(Action.CONFIRM_ACCOUNT, {
        confirmation_code: this.confirmation_code,
        phone_number: this.phone_number
      })
      .then(_ => {
        this.$router.push({
          path: "login"
        });
      })
      .catch(error => {
        this.error = error.response.data.message;
      });
  }

  hasError() {
    return this.error.length > 0;
  }

  resendCode() {
    this.$store
      .dispatch(Action.RESEND_CONFIRMATION, {
        phone_number: this.phone_number
      })
      .catch(error => {
        this.error = error.response.data.message;
      });
  }

  created() {
    if (typeof this.$route.query.phone_number === "string") {
      this.phone_number = this.$route.query.phone_number;
    }
  }
}
